document.addEventListener('page:loaded', function() {
  var acc = document.getElementsByClassName("accordion");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      } 
    });
  }

  $(".video-thumbnail").click(function() {
    console.log("clicked");
    $(".video-thumbnail-image").css("display", "none");
  });

});

document.addEventListener('Searchanise.Loaded', function () {
  var SearchaniseResponseData;

  (function ($) {
    $(document).on('Searchanise.DataRequestEnd', function (event, type, params, data) {
      SearchaniseResponseData = data;
    });

    $(document).on('Searchanise.ResultsUpdated', function (event, container) {
      SearchaniseResponseData.facets.forEach(function(f){
        if (f.appearance !== "color")
          return;

        f.buckets.forEach(function(b){
          let div = $(".snize-color-filter-checkbox span[title='"+b.title+"']").parent();
          if (!$('.snize-color-count', div).length) {
            div.append('<div class="snize-color-count">'+b.title+'</div>');
          }
        });
      });
    });
  })(window.Searchanise.$);
});

/* --- Klaviyo scroll-lock fix (31 Aug 2026) ---------------------------------
   theme.css hides Klaviyo forms on product pages:
     .template-product .needsclick.kl-private-reset-css-Xuajs1{display:none!important}
   Klaviyo still adds .klaviyo-prevent-body-scrolling to <body> when it opens
   the popup (~12s after load), so the page locks with no visible popup to
   close. This restores scrolling on product pages while the popup stays
   hidden. Deliberately NOT scoped wider: on other templates the popup is
   visible and its scroll lock is legitimate.
   Proper fix: exclude /products/ in the Klaviyo form's targeting, then delete
   the two kl-private-reset-css rules from theme.css and this block. */
(function () {
  var style = document.createElement('style');
  style.setAttribute('data-klaviyo-scroll-fix', '');
  style.appendChild(document.createTextNode(
    'body.template-product.klaviyo-prevent-body-scrolling{overflow:auto!important;}'
  ));
  (document.head || document.documentElement).appendChild(style);
})();
